<template>
	<div class="home_cont">
		<SubHeader msg="战场环境编辑子系统平台" />
		<div class="env_cont">
			<div class="envcont_left">
				<SubMenuLeft @func="getMsgmap" @func2="getMsgenvr" />
			</div>
			<div class="envcont_center">
				<SubMap />
				<SubInfoList />
			</div>
			<div class="envcont_right">
				<SubMenuRight />
			</div>
		</div>
		<!--地图设置-->
		<el-dialog class="mk1_dialog" title="地图设置" :visible.sync="mapVisible" >
			<MapDialog></MapDialog>
		</el-dialog>
		<!--环境设置-->
		<el-dialog class="mk1_dialog" title="环境设置" :visible.sync="envrVisible">
			<EnvrDialog></EnvrDialog>
		</el-dialog>
	</div>
</template>

<script>
	import SubHeader from '../components/subHeader.vue'
	import SubMenuLeft from '../components/subMenuLeft.vue'
	import SubMenuRight from '../components/subMenuRight.vue'
	import SubMap from '../components/subMap.vue'
	import SubInfoList from '../components/subInfoList.vue'
	
	import MapDialog from '../components/mapDialog.vue'
	import EnvrDialog from '../components/envrDialog.vue'
	
	export default {
		components: {
			SubHeader,
			SubMenuLeft,
			SubMenuRight,
			SubMap,
			SubInfoList,
			MapDialog,
			EnvrDialog
		},
		data() {
			return {
				mapVisible:false,
				envrVisible:false,
			}
		},
		methods:{
			getMsgmap(data){
				this.mapVisible = data;
			},
			getMsgenvr(data){
				this.envrVisible = data;
			},
		}
	}
</script>

<style>
	.env_cont{margin-top: 2%; display: flex; justify-content: space-between;overflow-y: auto; height: 90%;}
	.envcont_left{width: 15%;margin: 0 1%;height: 87vh;overflow: hidden;display: block;}
	.envcont_center{width: 65%;height: 87vh;display: block;overflow: hidden;}
	.envcont_right{width: 15%;margin: 0 1%;float: right;}
</style>
